import React from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useEffect, useState, Fragment } from "react";
import axios from "axios";
import { baseURL } from "../../constants/Api";
import BgSpa from "../../images/hotelSpaBg.png";
import SpaModal from "./SpaModal";
import SpaForm from "../../components/SpaForm";
import BackButton from "../bars/BackButton";
import CallImg from "../../images/call.svg";
import { convert_24_to_12, CurrencySymbol } from "../../utils/util";
import { SpaServicePageView } from "../../utils/Analytics";
function SpaCatagory() {
  const location = useLocation();
  // console.log(spaId);
  const currentUrl = window.location.href;
  const urlArray = currentUrl.split("/");
  const HotelIdSpaId = urlArray[urlArray.length - 1];
  const IdArray = HotelIdSpaId.split("-");
  const hotelId = IdArray[0];
  const spaId = IdArray[1];
  const SpaIdFromUrl = currentUrl.includes("SpaId-") 
  ? currentUrl.split("SpaId-")[1].split(currentUrl.includes("SpaRate-") && "-SpaRate-")[0] 
  : null;
  const SpaRateFromUrl = currentUrl.includes("SpaRate-") 
  ? currentUrl.split("SpaRate-")[1] 
  : null;
console.log("currentUrl",SpaIdFromUrl)
  const [hotelData, SethotelData] = useState([]);
  const [spaHide, SetspaHide] = useState(true);
  const [spaData, SetSpaData] = useState([]);
  const [spaName, SetSpaName] = useState("");
  const [showSpaModal, SetShowSpaModal] = useState(false);
  const [modalName, SetModalName] = useState("");
  const [modalImg, SetModalImg] = useState("");
  const [modalDescription, SetModalDescription] = useState("");
  const [modalRate, SetModalRate] = useState("");
  const [spaBooked, setSpaBooked] = useState(false);
  const [modalData, setModalData] = useState({});
  const [contactNumber, setContact] = useState();
  const [promotionId, SetPromotionId] = useState(null);
  const [spaBack,setspaBack] = useState('')
  useEffect(() => {
    window.scrollTo(0, 0);
    // if (localStorage.getItem("phone_no") == null) {
    //   navigate("../");
    // }
    if (location?.state) {
      // console.log(location?.state?.promotionId)
      if(location?.state?.spaLength){
        console.log("spaLength===========",location?.state.spaLength);
        setspaBack(location?.state.spaLength);
      }else if(location?.state?.promotionId){
        SetPromotionId(location?.state?.promotionId)
        console.log("spaLength===========",location?.state?.promotionId);
      }
    }
    // else if(location?.state[0]?.spaLength){
    //        console.log("spaLength===========",location?.state[0].spaLength);
    // }
    // console.log("object")
    const getSpaDetails = async () => {
      try {
        await axios({
          method: "post",
          url: `${baseURL}/api/spasV2`,

          data: {
            hotelId: hotelId,
            spaId: spaId,
          },

          headers: { "Content-Type": "application/json" },
        }).then(function (response) {
          // console.log("response.data.data[0].spaServices========================", response.data.data[0].spaServices)
          if (SpaIdFromUrl) {
            // console.log("spaId===================",SpaIdFromUrl)
            const reorderedSpaItems = [
              ...response.data.data[0].spaServices.filter(item => parseInt(item.id) === parseInt(SpaIdFromUrl)),
              ...response.data.data[0].spaServices.filter(item => parseInt(item.id) !== parseInt(SpaIdFromUrl))
            ];
            // console.log("reorderedItems=============================",reorderedItems)
            SetSpaData(reorderedSpaItems);
            SetSpaName(response.data.data[0].spaName);
            setContact(response.data.data[0].contactNumber);
          } else {
            SetSpaData(response.data.data[0].spaServices);
            SetSpaName(response.data.data[0].spaName);
            setContact(response.data.data[0].contactNumber);
          }

        });
      } catch { }
    };
    getSpaDetails();
    // console.log(location?.state?.promotionId)
    SpaServicePageView();
  }, []);
 


  useEffect(() => {
    // console.log("eventdata============",eventdata)
    if (spaData.length === 0) {
          console.log("Zero");
          setSpaBooked(false);
          SetShowSpaModal(false);
    } else {
      const promoObject = spaData.find((promo) => promo.id == SpaIdFromUrl);
      if(promoObject){
        setModalData(promoObject);
        setSpaBooked(true);
        SetShowSpaModal(false);
      }
    }
  }, [spaData]);

  const handleSpaModal = (spaData) => {
    setModalData(spaData);
    SetShowSpaModal(true);
  };

  const handleBookSpa = () => {
    setSpaBooked(true);
    SetShowSpaModal(false);
  };

   // currency setup
 const currencySymbol = CurrencySymbol();
  

  return (
    <div>
      {spaBooked == false ? (
        <div className="pb-28 relative">
          <img
            className="w-screen sm:h-[230px] h-[117px]"
            src={BgSpa}
            alt="bgHotelguide"
          />
          <div className="absolute top-3 left-3">
            <BackButton link={spaBack === 1 ? "/home" : ''}  whiteTheme={true}  /> 
          </div>
          <div className="section-wrap mx-4 mt-6 sm:mt-14">
            <div className="flex items-center justify-between guestName sm:text-center text-left">
              <span className="truncate w-[auto] max-w-[180px]">{spaName} </span>

              {contactNumber && <a href={`tel:${contactNumber}`}>
                <img src={CallImg} alt="" />
              </a>}
            </div>
            {(spaData[0]?.start_time && spaData[0]?.close_time) ?  <span className=" sm:text-xs text-[11px] text-[#9A9A9A] font-medium mb-1">
                           (Working hours - {convert_24_to_12(spaData[0]?.start_time ? spaData[0]?.start_time : '' )} to {convert_24_to_12(spaData[0]?.close_time ? spaData[0]?.close_time : '' ) })
                          </span>  :""}
            {/* <div className="text-[#9A9A9A] font-medium text-[11px]  sm:text-center text-left mt-2">
              Working Hours - 09.00 AM - 05.00 PM 
            </div> */}
            <>
              {spaData.length === 0 ? (
                <div className="flex items-center justify-center w-full h-[200px] text-center">
                  <p className="text-gray-500 text-lg">No spa categories available. Please check back later!</p>
                </div>
              ) : (
                <>
                  <div className="mt-5 text-semibold text-base text-[#FFF]">Categories  </div>
                  <div className="gridTab grid grid-flow-row grid-cols-2 gap-3 gap-x-4 mt-3">
                    {spaHide
                      ? spaData.map((spaItem, index) => (
                        <div key={index}>
                          <Link
                            onClick={() => handleSpaModal(spaItem)}
                            className="flex flex-col p-2 w-full bg-[#342F4F] rounded-md hover:shadow-lg transition-all"
                          >
                            <div className="w-full flex justify-center items-stretch bg-gray-200 rounded-md overflow-hidden h-[106px] sm:h-[160px]">
                            {spaItem.image ? (
                              <img
                                width="100%"
                                height="100%"
                                className="flex items-stretch bg-contain object-cover transition w-full h-full"
                                src={spaItem.image}
                                alt="hotelGuide"
                              />
                            ):("")}
                            </div>
                            <div className="mt-2 sm:text-base text-[14px] font-medium pb-2 w-full truncate">
                              {spaItem.serviceName}
                            </div>
                            <div className="text-[#D3D3D3] text-sm font-medium my-1">
                              Rate: {spaItem.rate >0 ?  <>{currencySymbol}{spaItem.rate}</> : 'Free'}
                            </div>
                          </Link>
                        </div>
                      ))
                      : null}
                  </div>
                </>
              )}
            </>
          </div>
        </div>
      ) : (
        <div className="mb-28">
          {console.log(location)}
          <SpaForm spaData={modalData} spaId={spaId} promotionId={promotionId} Rate={SpaRateFromUrl}  currencySymbol={currencySymbol}/>
        </div>
      )}

      {showSpaModal && (
        <SpaModal
          catagoryName={modalData.serviceName}
          description={modalData.description}
          image={modalData.image}
          rate={modalData.rate}
          gst={modalData.gst}
          hide={() => SetShowSpaModal(false)}
          onBookSpa={handleBookSpa}
          currencySymbol={currencySymbol}
        />
      )}
    </div>
  );
}

export default SpaCatagory;
